<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div class="form-group col-sm-12 required">
        <label for="account_id">Account:</label>
        <Multiselect mode="multiple" required v-model="value_multiple_sales" :options="accountOptions" valueProp="valueProp" label="label" :searchable="true">
          <template v-slot:multiplelabel="{ values }">
            <div class="multiselect-multiple-label">
              <span v-for="(item2, index2) in values" :key="index2">{{item2.label}},&nbsp;&nbsp;</span>
            </div>
          </template>
        </Multiselect>
      </div>
      <div class="form-group col-sm-12 required">
        <label for="sales_name">Sales Name:</label>
        <input class="form-control" name="sales_name" required type="text" v-model="sales.sales_name" maxlength="255">
      </div>
      <div class="form-group col-sm-12 required">
        <label for="sales_code">Sales Code:</label>
        <input class="form-control" name="sales_code" required type="text" v-model="sales.sales_code" maxlength="50">
      </div>
      <div class="form-group col-sm-12 required">
        <label for="status">Status:</label>        
        <select class="form-control" required name="status" v-model.number="sales.status">
          <option value="1" style="color:black;">Active</option>
          <option value="2" style="color:black;">Inactive</option>
        </select>
      </div>
      <div class="form-group col-sm-12">
        <input class="btn btn-primary" type="submit" value="Save">
        <router-link class="btn btn-default ml-1" to="/sales">Cancel</router-link>
      </div>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </form>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Multiselect from '@vueform/multiselect'
  export default {
    computed: {
        ...mapState('accounts', ['accounts']),
        ...mapState('sales', ['onRequest']),
    },
    data(){
      return {
        sales: {
          sales_name: '',
          sales_code: '',
          status: 1,
        },
        accountOptions: [],
        value_multiple_sales: null,
      }
    },
    components:{
        Multiselect
    },
    methods: {
      handleSubmit(){
        if(this.onRequest) return;
        let res = []
        this.value_multiple_sales.map(item => {
          res.push(item)
        })
        this.sales.sales_accounts = res
        this.add(this.sales)
      },
      ...mapActions('sales', ['add']),
      ...mapActions('accounts', ['get_all']),
    },
    created() {
      this.$emit('onChildInit', 'Add New Sales')
      this.get_all()
    },
    watch: {
      accounts(nextState, prevState){
        if(nextState !== prevState){
          this.accountOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.accountOptions.push({valueProp:item.id, label:item.account_name})
            })
          }
          return
        }
      },
    }
  }
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
